export enum ComponentState {
  blank = "BLANK",
  loading = "LOADING",
  erroring = "ERRORING",
  ready = "READY",
  success = "SUCCESS",
}
